import React from 'react';

import classNames from 'classnames';

import {useFeature} from 'components/feature';
import {FormattedAddressType} from 'desktop/types/addressType';
import {useIsOneStepAvailable} from 'hooks/useIsOneStepAvailable/useIsOneStepAvailable';

import {AddressesFacelift} from '../addressesFacelift/addressesFacelift';

import s from './addresses.scss';

const firstLine: Array<keyof FormattedAddressType> = ['name', 'phone', 'email'];

const secondLine: Array<keyof FormattedAddressType> = [
    'address',
    'city',
    'code',
    'state',
    'country',
];

export type PropsType = {
    addresses: FormattedAddressType;
    isDeliveryStepResume?: boolean;
};

/**
 * Address for checkout
 * @param {PropsType} props - Received address components
 * @returns {ReactElement} - Customer address components
 */
export const Addresses: React.FC<PropsType> = ({addresses, isDeliveryStepResume}) => {
    const {isOneStepAvailable} = useIsOneStepAvailable();
    const isFacelift = useFeature('dCheckoutFacelift');

    if (isFacelift && !isOneStepAvailable) {
        return <AddressesFacelift addresses={addresses} />;
    }

    return (
        <div
            className={classNames(s.components, {
                [s.forDeliveryStepResume]: isDeliveryStepResume,
                [s.oneStep]: isOneStepAvailable,
            })}
        >
            <div className={s.line}>
                {firstLine.map(
                    key =>
                        addresses[key] && (
                            <span className={s.component} key={key}>
                                {addresses[key]}
                            </span>
                        ),
                )}
            </div>
            <div className={s.line}>
                {secondLine.map(
                    key =>
                        addresses[key] && (
                            <span className={s.component} key={key}>
                                {addresses[key]}
                            </span>
                        ),
                )}
            </div>
        </div>
    );
};
